import { ErrorBoundary } from '@jci/components/ErrorBoundary';
import { useSession } from 'next-auth/react';
import Link from 'next/link';
import { HOME_PAGE } from '../config';
import type { ErrorBoundaryProps } from '../utils/appDirTypes';
import { Navbar } from './Navbar';

export default function GlobalErrorContent({
  error,
  reset,
}: ErrorBoundaryProps) {
  const session = useSession();
  return (
    <div className="flex min-h-screen flex-col items-center bg-base-200">
      <Navbar session={session.data} />
      <div className="flex w-full max-w-screen-2xl flex-1 flex-col px-8 py-7">
        <ErrorBoundary
          error={error}
          reset={() => reset()}
          homeUrl={HOME_PAGE}
        />
      </div>
      <div className="flex w-full justify-center gap-4 bg-base-200 pb-4 shadow-sm">
        <Link
          href={
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            new URL(
              `https://www.johnsoncontrols.com/privacy-center/global-privacy-notice`,
            ).toString() as any
          }
          target="_blank"
          rel="noopener noreferrer"
          className="link"
        >
          Privacy Policy
        </Link>
      </div>
    </div>
  );
}
